import {
  useEffect,
  useState,
  type Dispatch,
  type SetStateAction,
} from "react";

// Carousel index that stays in range when `itemCount` shrinks (e.g. streaming updates). Prevents `items[index]` from becoming undefined.
export function useClampedGalleryIndex(itemCount: number): {
  safeIndex: number;
  currentImageIndex: number;
  setCurrentImageIndex: Dispatch<SetStateAction<number>>;
} {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const safeIndex =
    itemCount > 0 ? Math.min(currentImageIndex, itemCount - 1) : 0;

  useEffect(() => {
    if (itemCount === 0) return;
    setCurrentImageIndex((prev) => Math.min(prev, itemCount - 1));
  }, [itemCount]);

  return { safeIndex, currentImageIndex, setCurrentImageIndex };
}
